/**
 * Usage Reports Actions
 * NgRx actions for usage reports state management
 */
import { createAction, props } from '@ngrx/store';
import { UsageStats, DailyUsage, ProcessingLog, UsageReportFilters } from '../models/usage-reports.models';

// Load Usage Stats
export const loadUsageStats = createAction(
  '[Usage Reports] Load Usage Stats',
  props<{ dateRange: string }>()
);

export const loadUsageStatsSuccess = createAction(
  '[Usage Reports] Load Usage Stats Success',
  props<{ stats: UsageStats }>()
);

export const loadUsageStatsFailure = createAction(
  '[Usage Reports] Load Usage Stats Failure',
  props<{ error: string }>()
);

// Load Daily Usage
export const loadDailyUsage = createAction(
  '[Usage Reports] Load Daily Usage',
  props<{ dateRange: string }>()
);

export const loadDailyUsageSuccess = createAction(
  '[Usage Reports] Load Daily Usage Success',
  props<{ dailyUsage: DailyUsage[] }>()
);

export const loadDailyUsageFailure = createAction(
  '[Usage Reports] Load Daily Usage Failure',
  props<{ error: string }>()
);

// Load Processing Logs
export const loadProcessingLogs = createAction(
  '[Usage Reports] Load Processing Logs',
  props<{ filters: UsageReportFilters; page: number; pageSize: number }>()
);

export const loadProcessingLogsSuccess = createAction(
  '[Usage Reports] Load Processing Logs Success',
  props<{ logs: ProcessingLog[]; total: number }>()
);

export const loadProcessingLogsFailure = createAction(
  '[Usage Reports] Load Processing Logs Failure',
  props<{ error: string }>()
);

// Update Filters
export const updateFilters = createAction(
  '[Usage Reports] Update Filters',
  props<{ filters: Partial<UsageReportFilters> }>()
);

// Change Page
export const changePage = createAction(
  '[Usage Reports] Change Page',
  props<{ page: number }>()
);

export const changePageSize = createAction(
  '[Usage Reports] Change Page Size',
  props<{ pageSize: number }>()
);

// Export Report
export const exportReport = createAction(
  '[Usage Reports] Export Report',
  props<{ format: 'csv' | 'pdf' }>()
);

export const exportReportSuccess = createAction(
  '[Usage Reports] Export Report Success'
);

export const exportReportFailure = createAction(
  '[Usage Reports] Export Report Failure',
  props<{ error: string }>()
);

// Clear Error
export const clearError = createAction('[Usage Reports] Clear Error');

